import { HTTPStatusCode } from "@libs/api/types";
import { CreatePatientShortCodeType } from "@/domain/patientShortCodes";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const PatientShortCodesApi = {
  assignPatientShortCodeData: async (body: CreatePatientShortCodeType) => {
    const res =
      await tsRestClient().patientsShortCodes.assignPatientShortCodeData({
        body,
      });

    if (
      res.status === HTTPStatusCode.CREATED ||
      res.status === HTTPStatusCode.OK
    ) {
      return res.body;
    }

    logger.error({
      message:
        "Unexpected response in PatientShortCodesApi.assignPatientShortCodeData",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
